import { render, staticRenderFns } from "./MetricsSummaryBlock.vue?vue&type=template&id=f6e94368&scoped=true&"
import script from "./MetricsSummaryBlock.vue?vue&type=script&lang=js&"
export * from "./MetricsSummaryBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e94368",
  null
  
)

export default component.exports